<template>
  <div class="card modal-card is-min-width-500">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h3 class="title is-size-3">
            {{ $t('declarationTlpe.popup.generationCommandeTlpe.title') }}
          </h3>
          <h3 class="title is-size-5">
            {{ $t('declarationTlpe.popup.generationCommandeTlpe.subTitle',
              subtitle ) }}
          </h3>
        </div>
      </div>
    </div>
    <div class="modal-card-body">
      <div class="card-content pdv-0">
        <error-msg-component :messages="messagesErreurPopup"
                             :error="isErrorPopup"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="isErrorPopup = $event"/>
        <div class="columns is-multiline">
          <b-field class="column is-5 obligatoire"
            :label="$t('declarationTlpe.popup.generationCommandeTlpe.declarant')" />
          <user-selector
            v-model="utilisateurIdSelected"
            class="column is-7"
            obligatoire
          />
        </div>
      </div>
      <footer class="mgt-20px">
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="generationCommandes()">
              {{ $t('general.button.apply')}}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import {
  DECLARATION,
  DECLARATION_AU_FIL_DE_LEAU,
} from '@/configuration/gabed/tlpe/tlpeConf';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import userSelector from '@/components/commun/user/userSelector';

const User = createNamespacedHelpers('user');

export default {
  props: {
    subtitle: {
      type: Object,
      required: true,
    },
    isErrorPopup: {
      type: Boolean,
      required: false,
      default: false,
    },
    messagesErreurPopup: {
      type: Array,
      required: false,
    },
    isAuFilDeLeau: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      utilisateurIdSelected: null,
    };
  },
  components: {
    errorMsgComponent,
    userSelector,
  },
  methods: {
    generationCommandes() {
      const typeDeclaration = this.isAuFilDeLeau
        ? DECLARATION_AU_FIL_DE_LEAU
        : DECLARATION;
      const args = {
        typeDeclaration,
        userId: this.utilisateurIdSelected,
      };
      this.$emit('generationCommandes', args);
    },
  },
  computed: {
    ...User.mapGetters({
      utilisateur: 'user',
    }),
  },
  mounted() {
    this.utilisateurIdSelected = this.utilisateur.id || null;
  },
};
</script>
